import { showError, showSuccess } from '../../Components/reuse/Toast';
import api from '../../api/axios';

// Action Types
export const ADD_SUPPRESS_EMAIL_REQUEST = 'ADD_SUPPRESS_EMAIL_REQUEST';
export const ADD_SUPPRESS_EMAIL_SUCCESS = 'ADD_SUPPRESS_EMAIL_SUCCESS';
export const ADD_SUPPRESS_EMAIL_FAILURE = 'ADD_SUPPRESS_EMAIL_FAILURE';

export const DELETE_SUPPRESS_EMAIL_REQUEST = 'DELETE_SUPPRESS_EMAIL_REQUEST';
export const DELETE_SUPPRESS_EMAIL_SUCCESS = 'DELETE_SUPPRESS_EMAIL_SUCCESS';
export const DELETE_SUPPRESS_EMAIL_FAILURE = 'DELETE_SUPPRESS_EMAIL_FAILURE';

export const LIST_SUPPRESS_EMAILS_REQUEST = 'LIST_SUPPRESS_EMAILS_REQUEST';
export const LIST_SUPPRESS_EMAILS_SUCCESS = 'LIST_SUPPRESS_EMAILS_SUCCESS';
export const LIST_SUPPRESS_EMAILS_FAILURE = 'LIST_SUPPRESS_EMAILS_FAILURE';

// Action Creators

// POST: setting/addSuppressEmail
export const addSuppressEmail = (emailData) => async (dispatch) => {
  dispatch({ type: ADD_SUPPRESS_EMAIL_REQUEST });
  
  try {
    const response = await api.post('setting/addSuppressEmail', emailData);
    
    if (response.data.success) {
      dispatch({ 
        type: ADD_SUPPRESS_EMAIL_SUCCESS, 
        payload: {
          data: response.data.data,
          message: response.data.message || 'Email suppressed successfully'
        }
      });
      showSuccess(response.data.message || 'Email suppressed successfully');
    } else {
      const errorMessage = response.data.message || 'Failed to add suppress email';
      dispatch({ 
        type: ADD_SUPPRESS_EMAIL_FAILURE, 
        error: errorMessage
      });
      showError(errorMessage);
    }
  } catch (error) {
    console.error('Failed to add suppress email:', error);
    const errorMessage = error?.response?.data?.message || 'Failed to add suppress email';
    dispatch({ 
      type: ADD_SUPPRESS_EMAIL_FAILURE, 
      error: errorMessage
    });
    showError(errorMessage);
  }
};

// POST: setting/deleteSuppressEmail
export const deleteSuppressEmail = (id) => async (dispatch) => {
  dispatch({ type: DELETE_SUPPRESS_EMAIL_REQUEST });
  
  try {
    const response = await api.post('setting/deleteSuppressEmail', { id });
    
    if (response.data.success) {
      dispatch({ 
        type: DELETE_SUPPRESS_EMAIL_SUCCESS,
        payload: {
          id,
          message: response.data.message || 'Email unsuppressed successfully'
        }
      });
      showSuccess(response.data.message || 'Email unsuppressed successfully');
    } else {
      const errorMessage = response.data.message || 'Failed to delete suppress email';
      dispatch({ 
        type: DELETE_SUPPRESS_EMAIL_FAILURE, 
        error: errorMessage
      });
      showError(errorMessage);
    }
  } catch (error) {
    console.error('Failed to delete suppress email:', error);
    const errorMessage = error?.response?.data?.message || 'Failed to delete suppress email';
    dispatch({ 
      type: DELETE_SUPPRESS_EMAIL_FAILURE, 
      error: errorMessage
    });
    showError(errorMessage);
  }
};

// GET: setting/listSuppressEmails
export const listSuppressEmails = (page = 1, limit = 25, searchKeyword = "") => async (dispatch) => {
  dispatch({ type: LIST_SUPPRESS_EMAILS_REQUEST, payload: { page, limit, searchKeyword } });
  
  try {
    const response = await api.get('setting/listSuppressEmails', {
      params: {
        page,
        limit,
        email:searchKeyword
      }
    });
    
    if (response.data.success) {
      dispatch({ 
        type: LIST_SUPPRESS_EMAILS_SUCCESS, 
        payload: response.data.data || response.data
      });
      return response.data;
    } else {
      const errorMessage = response.data.message || 'Failed to fetch suppress emails';
      dispatch({ 
        type: LIST_SUPPRESS_EMAILS_FAILURE, 
        error: errorMessage
      });
      showError(errorMessage);
      return { success: false, error: errorMessage };
    }
  } catch (error) {
    console.error('Failed to fetch suppress emails:', error);
    const errorMessage = error?.response?.data?.message || 'Failed to fetch suppress emails';
    dispatch({ 
      type: LIST_SUPPRESS_EMAILS_FAILURE, 
      error: errorMessage
    });
    showError(errorMessage);
  }
};

